"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "../../../client-utils/styled/index.js";
import { DOUBLE, TRIPLE } from "../../../constants/numbers.consts.js";
import Box from "../../../components/atoms/Box/index.js";
const coreComponentName = "SdbPopupMenu";
export const Root = styled(Box, {
    name: coreComponentName,
    slot: "Root",
})(({ theme }) => ({
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    borderRadius: 0,
    backgroundColor: theme.vars.palette.surface.container,
}));
const BoxMain = (props) => _jsx(Box, { ...props, component: "main" });
export const Main = styled(BoxMain, {
    name: coreComponentName,
    slot: "Main",
})(({ theme }) => ({
    overflowY: "auto",
    scrollbarGutter: "stable both-edges",
    flexGrow: 1,
    padding: theme.spacing(DOUBLE, TRIPLE),
}));
